import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { TaskSettingsRoutes } from '@/modules/to/tasksettings/tasksettings.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/tasksettings/:tab?',
      name: TaskSettingsRoutes.TASK_SETTINGS,
      component: () =>
        import(/* webpackChunkName: "task-settings-page" */ './pages/TaskSettingsPage.vue'),
      props: true,
    },
    {
      path: '/tasksettings/actions/:actionId',
      name: TaskSettingsRoutes.TASK_TEMPLATE_LIST,
      component: () =>
        import(
          /* webpackChunkName: "task-template-list-page" */ '../task/pages/TaskTemplateListPage.vue'
        ),
      props: true,
    },
  ],
  Module.QUEUE
);
